import React from 'react';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route} from 'react-router-dom';
import {createStore, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import 'semantic-ui-css/semantic.min.css';
import 'flexboxgrid/dist/flexboxgrid.min.css';
import 'react-s-alert/dist/s-alert-default.css';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import rootReducer from './stores/rootReducer';
import { loadState, logOut, saveState } from './actions/auth';
import {api} from './api';

let store = null;
if (process.env.NODE_ENV === 'production') {
    store = createStore(rootReducer, applyMiddleware(thunk));
} else {
    store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
}

const auth = loadState('dls-user');
try {
    if (!auth) {
        throw new Error("No local auth");
    }

    const now = Math.floor(Date.now() / 1000);
    const duration = 60*60*24*7;
    const remaining = Math.abs(now - auth.issued);
    if (remaining > duration) {
        throw new Error("Expired Token");
    }
    
    api.system.status(auth.jwt).then(res => {
        auth.jwt = res.data.data.next_token;
        auth.issued = Math.floor(Date.now() / 1000);
        store.dispatch({
            type: 'USER_LOGGED_IN',
            payload: auth
        })
        saveState(auth, 'dls-user');
        api.system.resources(auth.jwt).then(res => {
            store.dispatch({
                type: 'SYSTEM_BOOT_RESOURCES_LOADED',
                payload: res.data.data
            })
            ReactDOM.render(
                <BrowserRouter>
                    <Provider store={store}>
                        <Route render={props => <App authenticated={true} {...props} />} />
                    </Provider>
                </BrowserRouter>, document.getElementById('root'));
            registerServiceWorker();
        }).catch(err => {
            ReactDOM.render(
                <BrowserRouter>
                    <Provider store={store}>
                        <Route render={props => <App authenticated={false} {...props} />} />
                    </Provider>
                </BrowserRouter>, document.getElementById('root'));
            registerServiceWorker();
        })
    }).catch(err => {
        logOut()
        ReactDOM.render(
            <BrowserRouter>
                <Provider store={store}>
                    <Route render={props => <App authenticated={false} {...props} />} />
                </Provider>
            </BrowserRouter>, document.getElementById('root'));
        registerServiceWorker();
    })
} catch (e) {
    ReactDOM.render(
        <BrowserRouter>
            <Provider store={store}>
                <Route render={props => <App authenticated={false} {...props} />} />
            </Provider>
        </BrowserRouter>, document.getElementById('root'));
    registerServiceWorker();
}







// if (auth) {
//     if (!auth.issued) {
//         logOut();
//     }
//     const now = Math.floor(Date.now() / 1000);
//     const duration = 60*60*24*7;
//     const remaining = Math.abs(now - auth.issued);
//     if (remaining > duration) {
//         logOut();
//     } else {
//         api.system.status(auth.jwt).then(res => {
//             auth.jwt = res.data.data.next_token;
//             auth.issued = Math.floor(Date.now() / 1000);
//             store.dispatch({
//                 type: 'USER_LOGGED_IN',
//                 payload: auth
//             })
//             saveState(auth, 'dls-user');
//             api.system.resources(auth.jwt).then(res => {
//                 store.dispatch({
//                     type: 'SYSTEM_BOOT_RESOURCES_LOADED',
//                     payload: res.data.data
//                 })
//             })
//         }).catch(err => {
//             logOut()
//         })
//     }
// }
// if (!auth) {
//     logOut()
// }


// WEBPACK FOOTER //
// ./src/index.js